// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606300416/js/" + chunkId + "." + {"44":"471b9439","225":"ac9a4079","481":"a98c78e7","486":"39ec5e35","770":"7a76548c"}[chunkId] + ".0.8634833675650285.chunk.js";
};